import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import dayjs from 'dayjs';

import * as actions from './tag-manager.actions';
import { NewsletterType } from './tag-manager.actions';
import { AvailabilityWidgetInterface } from './tag-manager.interface';

@Injectable()
export class TagManagerFacade {
	private readonly store = inject(Store);

	formSubmit(subject: string) {
		this.store.dispatch(actions.formSubmit({ formSubject: subject }));
	}

	newsletterSubmit(
		emailAddress: string,
		newsletterType: NewsletterType = 'leisure',
	) {
		this.store.dispatch(
			actions.newsletterSubmit({ emailAddress, newsletterType }),
		);
	}

	giftcardOrderB2B(
		emailAddress: string,
		phoneNumber: string,
		companyName: string,
	) {
		this.store.dispatch(
			actions.giftcardOrderB2B({
				emailAddress,
				phoneNumber,
				companyName,
			}),
		);
	}

	giftcardOrderB2C(
		numCards: number,
		orderValue: number,
		emailAddress: string,
		phoneNumber: string,
	) {
		this.store.dispatch(
			actions.giftcardOrderB2C({
				numCards,
				orderValue,
				emailAddress,
				phoneNumber,
			}),
		);
	}

	quoteRequest(
		emailAddress: string,
		phoneNumber: string,
		companyName: string,
	) {
		this.store.dispatch(
			actions.quoteRequest({ emailAddress, phoneNumber, companyName }),
		);
	}

	availabilityWidget(eventData: AvailabilityWidgetInterface) {
		this.store.dispatch(actions.availabilityWidget(eventData));
	}

	getDayTypeToday() {
		return dayjs().day() === 0 || dayjs().day() === 6
			? 'weekend'
			: 'weekday';
	}

	getDayTypeArrival(arrivalDateString: string) {
		const arrivalDay = dayjs(arrivalDateString).day();
		return arrivalDay === 5 || arrivalDay === 6 ? 'weekend' : 'weekday';
	}

	getNumberOfDaysToArrival(arrivalDateString: string) {
		return dayjs(arrivalDateString)
			.startOf('day')
			.diff(dayjs().startOf('day'), 'day');
	}
}
